import { AnimatedSection } from '@denqfabrik/landing-ui';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { getRoutesForLang } from '../../i18n/routes';

export default function UseCasesSection() {
  const { t, lang } = useTranslation();
  const { label, heading, headingHighlight, description, viewAllButton, cards } = t.useCases;
  const routes = getRoutesForLang(lang);
  const allHref = `/${lang}${routes['use-cases']}`;

  return (
    <section id="use-cases" data-nav-theme="light" className="bg-[#f2f5fa] py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <AnimatedSection>
          <div className="mx-auto mb-4 max-w-3xl text-center">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.2em] text-sky-500">
              {label}
            </p>
            <h2 className="font-display text-4xl font-bold tracking-tight text-slate-900 md:text-5xl lg:text-6xl">
              {heading}{' '}
              <span className="bg-gradient-to-r from-sky-400 to-blue-500 bg-clip-text text-transparent">
                {headingHighlight}
              </span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-slate-600">
              {description}
            </p>
          </div>
        </AnimatedSection>

        {/* Cards */}
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {cards.map((card, i) => (
            <AnimatedSection key={card.slug} delay={i * 100}>
              <div className="flex h-full flex-col rounded-[18px] border border-[#dce2eb] bg-white p-8 shadow-sm transition-shadow hover:shadow-md">
                <span className="mb-4 text-3xl">{card.icon}</span>
                <h3 className="mb-2 text-lg font-bold text-slate-900">{card.title}</h3>
                <p className="text-[0.94rem] leading-relaxed text-slate-600">{card.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>

        {/* View all */}
        <AnimatedSection delay={500}>
          <div className="mt-10 text-center">
            <Link
              to={allHref}
              className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-8 py-3.5 text-sm font-semibold text-white transition-all hover:bg-slate-800"
            >
              {viewAllButton}
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12H19M12 5L19 12L12 19" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Link>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
